export default function getSearchTerm(term) {
  return term?.replace(/[^a-zA-Z0-9]/g, ' ');
}
